import { render, staticRenderFns } from "./label-202510.vue?vue&type=template&id=1ed410ac&scoped=true"
import script from "./label-202510.vue?vue&type=script&lang=js"
export * from "./label-202510.vue?vue&type=script&lang=js"
import style0 from "./label-202510.vue?vue&type=style&index=0&id=1ed410ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed410ac",
  null
  
)

export default component.exports